import { CircleX } from "lucide-react";

const SheriffAuctionDetails = ({ handleCancel, handleNext }) => {
  return (
    <div style={{ padding: 0 }} className="Schedule_new_case_modal_wrapper">
      <div
        style={{
          height: "100%",
          width: "100%",
          overflowY: "auto",
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          padding: "20px",
        }}
      >
        <div
          style={{
            maxWidth: "560px",
            backgroundImage: "none",
          }}
          className="schedule-form-wrapper process-sheriff-modal"
        >
          <div className="schedule-form">
            <div className="schedule-form-header">
              <p>Auction Details</p>
              <button type="button" onClick={handleCancel}>
                <CircleX />
              </button>
            </div>
            <div className="deputy-sheriff-modal-container">
              <p className="suit-number">
                <span style={{ fontWeight: 600 }}>Suit number:</span>{" "}
                ID/ADR/1470/2020
              </p>
              <div className="process-sheriff-details-container">
                <p className="process-sheriff-details-title">
                  Judgment Debt Amount
                </p>

                <p className="process-sheriff-details-value">100,000</p>
              </div>
              <div className="process-sheriff-details-container">
                <p className="process-sheriff-details-title">
                  Total Auction Amount
                </p>

                <p className="process-sheriff-details-value">100,000</p>
              </div>
              <div className="process-sheriff-details-container">
                <p className="process-sheriff-details-title">Property Type</p>
                <div style={{ textAlign: "right" }}>
                  <p className="process-sheriff-details-value">100,000</p>
                  <p className="process-sheriff-details-commission">
                    3.5% Government commission
                  </p>
                </div>
              </div>

              <div className="sheriff-auction-items-container">
                <p className=".sheriff-auction-items-title">Auctioned items</p>
                <table>
                  <thead>
                    <th>Item</th>
                    <th>Winner</th>
                    <th>Sale amount</th>
                  </thead>
                  <tbody>
                    <tr>
                      <td>Car</td>
                      <td>Salman Lukman</td>
                      <td>#20,000</td>
                    </tr>
                    <tr>
                      <td>Car</td>
                      <td>Salman Lukman</td>
                      <td>#20,000</td>
                    </tr>
                    <tr>
                      <td>Car</td>
                      <td>Salman Lukman</td>
                      <td>#20,000</td>
                    </tr>
                  </tbody>
                </table>
                <div className="sheriff-auction-items-total-container">
                  <p>Total </p>
                  <p>#100,000</p>
                </div>
              </div>
              <div
                style={{
                  marginTop: "0px",
                  justifyContent: "flex-end",
                }}
                className="assign-case-button-group"
              >
                <button
                  style={{
                    maxWidth: "132px",
                    marginTop: "24px",
                  }}
                  type="button"
                  onClick={handleCancel}
                >
                  Back
                </button>
                <button
                  style={{
                    maxWidth: "224px",
                  }}
                  onClick={handleNext}
                >
                  Calculate commisson
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};
export default SheriffAuctionDetails;
